module.exports = {
  port: 8888,
  host: 'localhost'
};
